// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  ApproveInvoiceData,
  ApproveInvoiceErrors,
  ApproveInvoiceResponses,
  ApproveMeerwerkData,
  ApproveMeerwerkErrors,
  ApproveMeerwerkResponses,
  AttestKeuringData,
  AttestKeuringResponses,
  BatchCreateTasksData,
  BatchCreateTasksErrors,
  BatchCreateTasksResponses,
  ChooseDecisionData,
  ChooseDecisionErrors,
  ChooseDecisionResponses,
  ClarifyInvoiceData,
  ClarifyInvoiceErrors,
  ClarifyInvoiceResponses,
  ClerkWebhookData,
  ClerkWebhookResponses,
  CreateContactData,
  CreateContactResponses,
  CreateDecisionData,
  CreateDecisionResponses,
  CreateInvoiceData,
  CreateInvoiceResponses,
  CreateKeuringData,
  CreateKeuringResponses,
  CreateMeerwerkData,
  CreateMeerwerkResponses,
  CreateMilestoneData,
  CreateMilestoneResponses,
  CreatePlanData,
  CreatePlanResponses,
  CreateQuoteData,
  CreateQuoteResponses,
  CreateShareLinkData,
  CreateShareLinkResponses,
  CreateTaskData,
  CreateTaskResponses,
  CreateWerfverslagData,
  CreateWerfverslagResponses,
  DeleteAccountData,
  DeleteAccountResponses,
  DeleteContactData,
  DeleteContactErrors,
  DeleteContactResponses,
  DeleteDecisionData,
  DeleteDecisionErrors,
  DeleteDecisionResponses,
  DeleteDocumentData,
  DeleteDocumentErrors,
  DeleteDocumentResponses,
  DeleteInvoiceData,
  DeleteInvoiceErrors,
  DeleteInvoiceResponses,
  DeletePhotoData,
  DeletePhotoErrors,
  DeletePhotoResponses,
  DeletePlanData,
  DeletePlanErrors,
  DeletePlanResponses,
  DeleteQuoteData,
  DeleteQuoteErrors,
  DeleteQuoteResponses,
  DeleteTaskData,
  DeleteTaskErrors,
  DeleteTaskResponses,
  DownloadDocumentData,
  DownloadDocumentResponses,
  DownloadDocumentsZipData,
  DownloadDocumentsZipResponses,
  DownloadPhotoData,
  DownloadPhotoResponses,
  DownloadPlanData,
  DownloadPlanResponses,
  ExportAccountData,
  ExportAccountResponses,
  ExportActivityCsvData,
  ExportActivityCsvResponses,
  ExportBudgetCsvData,
  ExportBudgetCsvResponses,
  ExportContactsVCardData,
  ExportContactsVCardResponses,
  ExportMeerwerkenCsvData,
  ExportMeerwerkenCsvResponses,
  GetBudgetData,
  GetBudgetEstimatesData,
  GetBudgetEstimatesResponses,
  GetBudgetResponses,
  GetDashboardData,
  GetDashboardResponses,
  GetNotificationsData,
  GetNotificationsResponses,
  GetPhaseData,
  GetPhaseErrors,
  GetPhaseResponses,
  GetPhotoThumbnailData,
  GetPhotoThumbnailResponses,
  GetProjectData,
  GetProjectResponses,
  HealthData,
  HealthResponses,
  InviteUserData,
  InviteUserResponses,
  ListActivityData,
  ListActivityResponses,
  ListContactsData,
  ListContactsResponses,
  ListDecisionsData,
  ListDecisionsResponses,
  ListDocumentsData,
  ListDocumentsResponses,
  ListGarantiesData,
  ListGarantiesResponses,
  ListInvoicesData,
  ListInvoicesResponses,
  ListKeuringenData,
  ListKeuringenResponses,
  ListMeerwerkenData,
  ListMeerwerkenResponses,
  ListMilestonesData,
  ListMilestonesResponses,
  ListPhasesData,
  ListPhasesResponses,
  ListPhotosData,
  ListPhotosResponses,
  ListPlansData,
  ListPlansResponses,
  ListProjectMembersData,
  ListProjectMembersResponses,
  ListQuotesData,
  ListQuotesResponses,
  ListShareLinksData,
  ListShareLinksResponses,
  ListTasksData,
  ListTasksResponses,
  ListWerfverslagenData,
  ListWerfverslagenResponses,
  MailPhaseContactsData,
  MailPhaseContactsErrors,
  MailPhaseContactsResponses,
  ObjectInvoiceData,
  ObjectInvoiceResponses,
  RejectMeerwerkData,
  RejectMeerwerkErrors,
  RejectMeerwerkResponses,
  RotatePhotoData,
  RotatePhotoErrors,
  RotatePhotoResponses,
  SearchData,
  SearchResponses,
  SeedStandardKeuringenData,
  SeedStandardKeuringenErrors,
  SeedStandardKeuringenResponses,
  SelectQuoteData,
  SelectQuoteErrors,
  SelectQuoteResponses,
  SendWerfverslagData,
  SendWerfverslagErrors,
  SendWerfverslagResponses,
  SetBudgetEstimatesData,
  SetBudgetEstimatesResponses,
  SetTaskStatusData,
  SetTaskStatusErrors,
  SetTaskStatusResponses,
  SetTaskUrgentData,
  SetTaskUrgentErrors,
  SetTaskUrgentResponses,
  UpdateContactData,
  UpdateContactErrors,
  UpdateContactResponses,
  UpdateDecisionData,
  UpdateDecisionErrors,
  UpdateDecisionResponses,
  UpdateDocumentData,
  UpdateDocumentErrors,
  UpdateDocumentResponses,
  UpdateInvoiceData,
  UpdateInvoiceErrors,
  UpdateInvoiceResponses,
  UpdateKeuringData,
  UpdateKeuringErrors,
  UpdateKeuringResponses,
  UpdateMeerwerkData,
  UpdateMeerwerkErrors,
  UpdateMeerwerkResponses,
  UpdateNotificationsData,
  UpdateNotificationsResponses,
  UpdatePhaseData,
  UpdatePhaseErrors,
  UpdatePhaseResponses,
  UpdatePhotoData,
  UpdatePhotoErrors,
  UpdatePhotoResponses,
  UpdatePlanData,
  UpdatePlanErrors,
  UpdatePlanResponses,
  UpdateProjectData,
  UpdateProjectResponses,
  UpdateQuoteData,
  UpdateQuoteErrors,
  UpdateQuoteResponses,
  UpdateTaskData,
  UpdateTaskErrors,
  UpdateTaskResponses,
  UpdateWerfverslagData,
  UpdateWerfverslagErrors,
  UpdateWerfverslagResponses,
  UploadDocumentData,
  UploadDocumentResponses,
  UploadDocumentVersionData,
  UploadDocumentVersionResponses,
  UploadPhotoData,
  UploadPhotoResponses,
  UploadPlanData,
  UploadPlanResponses,
  UploadPlanVersionData,
  UploadPlanVersionResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const health = <ThrowOnError extends boolean = false>(
  options?: Options<HealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<HealthResponses, unknown, ThrowOnError>({
    url: '/api/health',
    ...options,
  });

/**
 * List project contacts, paginated.
 */
export const listContacts = <ThrowOnError extends boolean = false>(
  options?: Options<ListContactsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListContactsResponses, unknown, ThrowOnError>({
    url: '/api/contacts',
    ...options,
  });

/**
 * Create a new contact for the current project.
 */
export const createContact = <ThrowOnError extends boolean = false>(
  options: Options<CreateContactData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateContactResponses, unknown, ThrowOnError>({
    url: '/api/contacts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List project documents, filtered by phase, paginated.
 */
export const listDocuments = <ThrowOnError extends boolean = false>(
  options?: Options<ListDocumentsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListDocumentsResponses, unknown, ThrowOnError>({
    url: '/api/documents',
    ...options,
  });

/**
 * Upload a document (multipart/form-data).
 */
export const uploadDocument = <ThrowOnError extends boolean = false>(
  options: Options<UploadDocumentData, ThrowOnError>,
) =>
  (options.client ?? client).post<UploadDocumentResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * List project invoices, filtered by status, paginated.
 */
export const listInvoices = <ThrowOnError extends boolean = false>(
  options?: Options<ListInvoicesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListInvoicesResponses, unknown, ThrowOnError>({
    url: '/api/invoices',
    ...options,
  });

/**
 * Create a new invoice for the current project.
 */
export const createInvoice = <ThrowOnError extends boolean = false>(
  options: Options<CreateInvoiceData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateInvoiceResponses, unknown, ThrowOnError>({
    url: '/api/invoices',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List project decisions, filtered by status, paginated.
 */
export const listDecisions = <ThrowOnError extends boolean = false>(
  options?: Options<ListDecisionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListDecisionsResponses, unknown, ThrowOnError>({
    url: '/api/decisions',
    ...options,
  });

/**
 * Create a new decision for the current project.
 */
export const createDecision = <ThrowOnError extends boolean = false>(
  options: Options<CreateDecisionData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateDecisionResponses, unknown, ThrowOnError>({
    url: '/api/decisions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List project meerwerken, filtered by status, paginated.
 */
export const listMeerwerken = <ThrowOnError extends boolean = false>(
  options?: Options<ListMeerwerkenData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListMeerwerkenResponses, unknown, ThrowOnError>({
    url: '/api/meerwerken',
    ...options,
  });

/**
 * Create a new meerwerk for the current project.
 */
export const createMeerwerk = <ThrowOnError extends boolean = false>(
  options: Options<CreateMeerwerkData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateMeerwerkResponses, unknown, ThrowOnError>({
    url: '/api/meerwerken',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List project photos, filtered by phase, paginated.
 */
export const listPhotos = <ThrowOnError extends boolean = false>(
  options?: Options<ListPhotosData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListPhotosResponses, unknown, ThrowOnError>({
    url: '/api/photos',
    ...options,
  });

/**
 * Upload a photo (multipart/form-data).
 */
export const uploadPhoto = <ThrowOnError extends boolean = false>(
  options: Options<UploadPhotoData, ThrowOnError>,
) =>
  (options.client ?? client).post<UploadPhotoResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/photos',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * List werfverslagen, filtered by phase, paginated.
 */
export const listWerfverslagen = <ThrowOnError extends boolean = false>(
  options?: Options<ListWerfverslagenData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListWerfverslagenResponses, unknown, ThrowOnError>({
    url: '/api/werfverslagen',
    ...options,
  });

/**
 * Create a werfverslag for the current project.
 */
export const createWerfverslag = <ThrowOnError extends boolean = false>(
  options: Options<CreateWerfverslagData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateWerfverslagResponses, unknown, ThrowOnError>({
    url: '/api/werfverslagen',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List keuringen, paginated.
 */
export const listKeuringen = <ThrowOnError extends boolean = false>(
  options?: Options<ListKeuringenData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListKeuringenResponses, unknown, ThrowOnError>({
    url: '/api/keuringen',
    ...options,
  });

/**
 * Schedule a keuring for the current project.
 */
export const createKeuring = <ThrowOnError extends boolean = false>(
  options: Options<CreateKeuringData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateKeuringResponses, unknown, ThrowOnError>({
    url: '/api/keuringen',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List garanties, paginated.
 */
export const listGaranties = <ThrowOnError extends boolean = false>(
  options?: Options<ListGarantiesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListGarantiesResponses, unknown, ThrowOnError>({
    url: '/api/garanties',
    ...options,
  });

/**
 * List activity entries, newest first, paginated. Optional filters: types, from, to.
 */
export const listActivity = <ThrowOnError extends boolean = false>(
  options?: Options<ListActivityData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListActivityResponses, unknown, ThrowOnError>({
    url: '/api/activity',
    ...options,
  });

/**
 * List project tasks, filtered by status/phase, paginated.
 */
export const listTasks = <ThrowOnError extends boolean = false>(
  options?: Options<ListTasksData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListTasksResponses, unknown, ThrowOnError>({
    url: '/api/tasks',
    ...options,
  });

/**
 * Create a new task for the current project.
 */
export const createTask = <ThrowOnError extends boolean = false>(
  options: Options<CreateTaskData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateTaskResponses, unknown, ThrowOnError>({
    url: '/api/tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List supplier quotes, optionally filtered by subject, paginated.
 */
export const listQuotes = <ThrowOnError extends boolean = false>(
  options?: Options<ListQuotesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListQuotesResponses, unknown, ThrowOnError>({
    url: '/api/quotes',
    ...options,
  });

/**
 * Add a quote for the current project.
 */
export const createQuote = <ThrowOnError extends boolean = false>(
  options: Options<CreateQuoteData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateQuoteResponses, unknown, ThrowOnError>({
    url: '/api/quotes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List architectural/technical/structural plans, paginated.
 */
export const listPlans = <ThrowOnError extends boolean = false>(
  options?: Options<ListPlansData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListPlansResponses, unknown, ThrowOnError>({
    url: '/api/plans',
    ...options,
  });

/**
 * Create a plan for the current project.
 */
export const createPlan = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlanData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreatePlanResponses, unknown, ThrowOnError>({
    url: '/api/plans',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Composite dashboard payload: current phase, budget, open invoices, open decisions, recent activity.
 */
export const getDashboard = <ThrowOnError extends boolean = false>(
  options?: Options<GetDashboardData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDashboardResponses, unknown, ThrowOnError>({
    url: '/api/dashboard',
    ...options,
  });

/**
 * List all phases of the current project, ordered by start date.
 */
export const listPhases = <ThrowOnError extends boolean = false>(
  options?: Options<ListPhasesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListPhasesResponses, unknown, ThrowOnError>({
    url: '/api/phases',
    ...options,
  });

/**
 * Get a single phase by its phase ID code (e.g. 'Ruw').
 */
export const getPhase = <ThrowOnError extends boolean = false>(
  options: Options<GetPhaseData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetPhaseResponses, GetPhaseErrors, ThrowOnError>({
    url: '/api/phases/{phaseId}',
    ...options,
  });

/**
 * Update status, progress, or dates of a phase.
 */
export const updatePhase = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePhaseData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdatePhaseResponses, UpdatePhaseErrors, ThrowOnError>({
    url: '/api/phases/{phaseId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Current project's budget summary.
 */
export const getBudget = <ThrowOnError extends boolean = false>(
  options?: Options<GetBudgetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetBudgetResponses, unknown, ThrowOnError>({
    url: '/api/budget',
    ...options,
  });

/**
 * Receives Clerk webhook events (Svix-signed).
 */
export const clerkWebhook = <ThrowOnError extends boolean = false>(
  options?: Options<ClerkWebhookData, ThrowOnError>,
) =>
  (options?.client ?? client).post<ClerkWebhookResponses, unknown, ThrowOnError>({
    url: '/api/webhooks/clerk',
    ...options,
  });

/**
 * Read the current project's full state (name, address, dates, budget, phase, type).
 */
export const getProject = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetProjectResponses, unknown, ThrowOnError>({
    url: '/api/project',
    ...options,
  });

/**
 * Update the current project's name, address, dates, budget, phase, or type.
 */
export const updateProject = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateProjectResponses, unknown, ThrowOnError>({
    url: '/api/project',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a contact from the current project.
 */
export const deleteContact = <ThrowOnError extends boolean = false>(
  options: Options<DeleteContactData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteContactResponses, DeleteContactErrors, ThrowOnError>({
    url: '/api/contacts/{id}',
    ...options,
  });

/**
 * Update an existing contact.
 */
export const updateContact = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContactData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateContactResponses, UpdateContactErrors, ThrowOnError>({
    url: '/api/contacts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export all project contacts as a vCard 3.0 file.
 */
export const exportContactsVCard = <ThrowOnError extends boolean = false>(
  options?: Options<ExportContactsVCardData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportContactsVCardResponses, unknown, ThrowOnError>({
    url: '/api/contacts/vcard',
    ...options,
  });

/**
 * Upload a new binary as the next version of an existing document.
 */
export const uploadDocumentVersion = <ThrowOnError extends boolean = false>(
  options: Options<UploadDocumentVersionData, ThrowOnError>,
) =>
  (options.client ?? client).post<UploadDocumentVersionResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/documents/{id}/versions',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Remove a document and its file from disk.
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDocumentData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError>({
    url: '/api/documents/{id}',
    ...options,
  });

/**
 * Update document metadata (name, phase, version).
 */
export const updateDocument = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDocumentData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateDocumentResponses, UpdateDocumentErrors, ThrowOnError>({
    url: '/api/documents/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Stream the original uploaded file.
 */
export const downloadDocument = <ThrowOnError extends boolean = false>(
  options: Options<DownloadDocumentData, ThrowOnError>,
) =>
  (options.client ?? client).get<DownloadDocumentResponses, unknown, ThrowOnError>({
    url: '/api/documents/{id}/download',
    ...options,
  });

/**
 * Bundle the requested documents into a ZIP and stream it back.
 */
export const downloadDocumentsZip = <ThrowOnError extends boolean = false>(
  options: Options<DownloadDocumentsZipData, ThrowOnError>,
) =>
  (options.client ?? client).post<DownloadDocumentsZipResponses, unknown, ThrowOnError>({
    url: '/api/documents/zip',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a photo and its file from disk.
 */
export const deletePhoto = <ThrowOnError extends boolean = false>(
  options: Options<DeletePhotoData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeletePhotoResponses, DeletePhotoErrors, ThrowOnError>({
    url: '/api/photos/{id}',
    ...options,
  });

/**
 * Update photo metadata (caption, room, phase).
 */
export const updatePhoto = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePhotoData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdatePhotoResponses, UpdatePhotoErrors, ThrowOnError>({
    url: '/api/photos/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Rotate the original photo bytes by 90/180/270 degrees (positive = clockwise).
 */
export const rotatePhoto = <ThrowOnError extends boolean = false>(
  options: Options<RotatePhotoData, ThrowOnError>,
) =>
  (options.client ?? client).post<RotatePhotoResponses, RotatePhotoErrors, ThrowOnError>({
    url: '/api/photos/{id}/rotate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Serve thumbnail variant of a photo.
 */
export const getPhotoThumbnail = <ThrowOnError extends boolean = false>(
  options: Options<GetPhotoThumbnailData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetPhotoThumbnailResponses, unknown, ThrowOnError>({
    url: '/api/photos/{id}/thumb',
    ...options,
  });

/**
 * Stream the original uploaded photo file.
 */
export const downloadPhoto = <ThrowOnError extends boolean = false>(
  options: Options<DownloadPhotoData, ThrowOnError>,
) =>
  (options.client ?? client).get<DownloadPhotoResponses, unknown, ThrowOnError>({
    url: '/api/photos/{id}/download',
    ...options,
  });

/**
 * Remove an invoice from the current project.
 */
export const deleteInvoice = <ThrowOnError extends boolean = false>(
  options: Options<DeleteInvoiceData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteInvoiceResponses, DeleteInvoiceErrors, ThrowOnError>({
    url: '/api/invoices/{id}',
    ...options,
  });

/**
 * Update an existing invoice.
 */
export const updateInvoice = <ThrowOnError extends boolean = false>(
  options: Options<UpdateInvoiceData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateInvoiceResponses, UpdateInvoiceErrors, ThrowOnError>({
    url: '/api/invoices/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Approve & schedule payment for an invoice.
 */
export const approveInvoice = <ThrowOnError extends boolean = false>(
  options: Options<ApproveInvoiceData, ThrowOnError>,
) =>
  (options.client ?? client).post<ApproveInvoiceResponses, ApproveInvoiceErrors, ThrowOnError>({
    url: '/api/invoices/{id}/approve',
    ...options,
  });

/**
 * Register objection (bezwaar) for an invoice.
 */
export const objectInvoice = <ThrowOnError extends boolean = false>(
  options: Options<ObjectInvoiceData, ThrowOnError>,
) =>
  (options.client ?? client).post<ObjectInvoiceResponses, unknown, ThrowOnError>({
    url: '/api/invoices/{id}/object',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Request clarification for an invoice.
 */
export const clarifyInvoice = <ThrowOnError extends boolean = false>(
  options: Options<ClarifyInvoiceData, ThrowOnError>,
) =>
  (options.client ?? client).post<ClarifyInvoiceResponses, ClarifyInvoiceErrors, ThrowOnError>({
    url: '/api/invoices/{id}/clarify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update an existing meerwerk.
 */
export const updateMeerwerk = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMeerwerkData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateMeerwerkResponses, UpdateMeerwerkErrors, ThrowOnError>({
    url: '/api/meerwerken/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Approve a meerwerk (Goedgekeurd).
 */
export const approveMeerwerk = <ThrowOnError extends boolean = false>(
  options: Options<ApproveMeerwerkData, ThrowOnError>,
) =>
  (options.client ?? client).post<ApproveMeerwerkResponses, ApproveMeerwerkErrors, ThrowOnError>({
    url: '/api/meerwerken/{id}/approve',
    ...options,
  });

/**
 * Reject a meerwerk (Afgewezen).
 */
export const rejectMeerwerk = <ThrowOnError extends boolean = false>(
  options: Options<RejectMeerwerkData, ThrowOnError>,
) =>
  (options.client ?? client).post<RejectMeerwerkResponses, RejectMeerwerkErrors, ThrowOnError>({
    url: '/api/meerwerken/{id}/reject',
    ...options,
  });

/**
 * Export meerwerken list as CSV.
 */
export const exportMeerwerkenCsv = <ThrowOnError extends boolean = false>(
  options?: Options<ExportMeerwerkenCsvData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportMeerwerkenCsvResponses, unknown, ThrowOnError>({
    url: '/api/meerwerken/export',
    ...options,
  });

/**
 * Remove a decision from the current project.
 */
export const deleteDecision = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDecisionData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteDecisionResponses, DeleteDecisionErrors, ThrowOnError>({
    url: '/api/decisions/{id}',
    ...options,
  });

/**
 * Update an existing decision.
 */
export const updateDecision = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDecisionData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateDecisionResponses, UpdateDecisionErrors, ThrowOnError>({
    url: '/api/decisions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Choose an option for a decision, closing it.
 */
export const chooseDecision = <ThrowOnError extends boolean = false>(
  options: Options<ChooseDecisionData, ThrowOnError>,
) =>
  (options.client ?? client).post<ChooseDecisionResponses, ChooseDecisionErrors, ThrowOnError>({
    url: '/api/decisions/{id}/choose',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a task from the current project.
 */
export const deleteTask = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTaskData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteTaskResponses, DeleteTaskErrors, ThrowOnError>({
    url: '/api/tasks/{id}',
    ...options,
  });

/**
 * Update an existing task.
 */
export const updateTask = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTaskData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateTaskResponses, UpdateTaskErrors, ThrowOnError>({
    url: '/api/tasks/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Toggle the status of a task.
 */
export const setTaskStatus = <ThrowOnError extends boolean = false>(
  options: Options<SetTaskStatusData, ThrowOnError>,
) =>
  (options.client ?? client).patch<SetTaskStatusResponses, SetTaskStatusErrors, ThrowOnError>({
    url: '/api/tasks/{id}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Toggle the urgent flag of a task.
 */
export const setTaskUrgent = <ThrowOnError extends boolean = false>(
  options: Options<SetTaskUrgentData, ThrowOnError>,
) =>
  (options.client ?? client).patch<SetTaskUrgentResponses, SetTaskUrgentErrors, ThrowOnError>({
    url: '/api/tasks/{id}/urgent',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk-create tasks from werfverslag action items.
 */
export const batchCreateTasks = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateTasksData, ThrowOnError>,
) =>
  (options.client ?? client).post<BatchCreateTasksResponses, BatchCreateTasksErrors, ThrowOnError>({
    url: '/api/tasks/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a quote from the current project.
 */
export const deleteQuote = <ThrowOnError extends boolean = false>(
  options: Options<DeleteQuoteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteQuoteResponses, DeleteQuoteErrors, ThrowOnError>({
    url: '/api/quotes/{id}',
    ...options,
  });

/**
 * Update quote details.
 */
export const updateQuote = <ThrowOnError extends boolean = false>(
  options: Options<UpdateQuoteData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateQuoteResponses, UpdateQuoteErrors, ThrowOnError>({
    url: '/api/quotes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Mark quote as preferred (clears others for same subject).
 */
export const selectQuote = <ThrowOnError extends boolean = false>(
  options: Options<SelectQuoteData, ThrowOnError>,
) =>
  (options.client ?? client).post<SelectQuoteResponses, SelectQuoteErrors, ThrowOnError>({
    url: '/api/quotes/{id}/select',
    ...options,
  });

/**
 * Upload a plan with the underlying PDF (multipart/form-data).
 */
export const uploadPlan = <ThrowOnError extends boolean = false>(
  options: Options<UploadPlanData, ThrowOnError>,
) =>
  (options.client ?? client).post<UploadPlanResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/plans/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Replace the underlying PDF for an existing plan (multipart/form-data).
 */
export const uploadPlanVersion = <ThrowOnError extends boolean = false>(
  options: Options<UploadPlanVersionData, ThrowOnError>,
) =>
  (options.client ?? client).post<UploadPlanVersionResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/plans/{id}/versions',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Remove a plan from the current project.
 */
export const deletePlan = <ThrowOnError extends boolean = false>(
  options: Options<DeletePlanData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeletePlanResponses, DeletePlanErrors, ThrowOnError>({
    url: '/api/plans/{id}',
    ...options,
  });

/**
 * Update plan details.
 */
export const updatePlan = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePlanData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdatePlanResponses, UpdatePlanErrors, ThrowOnError>({
    url: '/api/plans/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Stream the plan's underlying PDF.
 */
export const downloadPlan = <ThrowOnError extends boolean = false>(
  options: Options<DownloadPlanData, ThrowOnError>,
) =>
  (options.client ?? client).get<DownloadPlanResponses, unknown, ThrowOnError>({
    url: '/api/plans/{id}/download',
    ...options,
  });

/**
 * Mail all responsible contacts for a phase (stub).
 */
export const mailPhaseContacts = <ThrowOnError extends boolean = false>(
  options: Options<MailPhaseContactsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MailPhaseContactsResponses,
    MailPhaseContactsErrors,
    ThrowOnError
  >({ url: '/api/phases/{phaseId}/mail', ...options });

/**
 * List milestones for the current project, optionally filtered by phase.
 */
export const listMilestones = <ThrowOnError extends boolean = false>(
  options?: Options<ListMilestonesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListMilestonesResponses, unknown, ThrowOnError>({
    url: '/api/milestones',
    ...options,
  });

/**
 * Create a milestone on the project timeline.
 */
export const createMilestone = <ThrowOnError extends boolean = false>(
  options: Options<CreateMilestoneData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateMilestoneResponses, unknown, ThrowOnError>({
    url: '/api/milestones',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update keuring details.
 */
export const updateKeuring = <ThrowOnError extends boolean = false>(
  options: Options<UpdateKeuringData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateKeuringResponses, UpdateKeuringErrors, ThrowOnError>({
    url: '/api/keuringen/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload attestation document for a keuring (multipart/form-data).
 */
export const attestKeuring = <ThrowOnError extends boolean = false>(
  options: Options<AttestKeuringData, ThrowOnError>,
) =>
  (options.client ?? client).post<AttestKeuringResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/keuringen/{id}/attest',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Voeg de Belgische standaardlijst van verplichte keuringen toe aan dit project.
 */
export const seedStandardKeuringen = <ThrowOnError extends boolean = false>(
  options: Options<SeedStandardKeuringenData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SeedStandardKeuringenResponses,
    SeedStandardKeuringenErrors,
    ThrowOnError
  >({ url: '/api/projects/{projectId}/keuringen/seed-standard', ...options });

/**
 * Update werfverslag items and attendees.
 */
export const updateWerfverslag = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWerfverslagData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateWerfverslagResponses, UpdateWerfverslagErrors, ThrowOnError>(
    {
      url: '/api/werfverslagen/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  );

/**
 * Mail the werfverslag to its attendee contacts.
 */
export const sendWerfverslag = <ThrowOnError extends boolean = false>(
  options: Options<SendWerfverslagData, ThrowOnError>,
) =>
  (options.client ?? client).post<SendWerfverslagResponses, SendWerfverslagErrors, ThrowOnError>({
    url: '/api/werfverslagen/{id}/send',
    ...options,
  });

/**
 * Export budget (all invoices) as CSV.
 */
export const exportBudgetCsv = <ThrowOnError extends boolean = false>(
  options?: Options<ExportBudgetCsvData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportBudgetCsvResponses, unknown, ThrowOnError>({
    url: '/api/budget/export',
    ...options,
  });

/**
 * Get the per-post expected costs for the current project.
 */
export const getBudgetEstimates = <ThrowOnError extends boolean = false>(
  options?: Options<GetBudgetEstimatesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetBudgetEstimatesResponses, unknown, ThrowOnError>({
    url: '/api/budget/estimates',
    ...options,
  });

/**
 * Upsert the per-post expected costs for the current project.
 */
export const setBudgetEstimates = <ThrowOnError extends boolean = false>(
  options: Options<SetBudgetEstimatesData, ThrowOnError>,
) =>
  (options.client ?? client).put<SetBudgetEstimatesResponses, unknown, ThrowOnError>({
    url: '/api/budget/estimates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export all workspace data as a GDPR-compliant ZIP archive.
 */
export const exportAccount = <ThrowOnError extends boolean = false>(
  options?: Options<ExportAccountData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportAccountResponses, unknown, ThrowOnError>({
    url: '/api/me/export',
    ...options,
  });

/**
 * Permanently delete the current user account and all associated data.
 */
export const deleteAccount = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteAccountData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<DeleteAccountResponses, unknown, ThrowOnError>({
    url: '/api/me',
    ...options,
  });

/**
 * Read the current user's notification preferences.
 */
export const getNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<GetNotificationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetNotificationsResponses, unknown, ThrowOnError>({
    url: '/api/settings/notifications',
    ...options,
  });

/**
 * Update notification preferences for the current user.
 */
export const updateNotifications = <ThrowOnError extends boolean = false>(
  options: Options<UpdateNotificationsData, ThrowOnError>,
) =>
  (options.client ?? client).put<UpdateNotificationsResponses, unknown, ThrowOnError>({
    url: '/api/settings/notifications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List active read-only share links for the current project.
 */
export const listShareLinks = <ThrowOnError extends boolean = false>(
  options?: Options<ListShareLinksData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListShareLinksResponses, unknown, ThrowOnError>({
    url: '/api/settings/share-links',
    ...options,
  });

/**
 * List members (bouwheer + collaborators) of the current project.
 */
export const listProjectMembers = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectMembersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListProjectMembersResponses, unknown, ThrowOnError>({
    url: '/api/settings/members',
    ...options,
  });

/**
 * Invite a user to the current project (stub).
 */
export const inviteUser = <ThrowOnError extends boolean = false>(
  options: Options<InviteUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<InviteUserResponses, unknown, ThrowOnError>({
    url: '/api/settings/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create a read-only share link for the current project.
 */
export const createShareLink = <ThrowOnError extends boolean = false>(
  options?: Options<CreateShareLinkData, ThrowOnError>,
) =>
  (options?.client ?? client).post<CreateShareLinkResponses, unknown, ThrowOnError>({
    url: '/api/settings/share-link',
    ...options,
  });

/**
 * Export the activity log for the current project as CSV.
 */
export const exportActivityCsv = <ThrowOnError extends boolean = false>(
  options?: Options<ExportActivityCsvData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExportActivityCsvResponses, unknown, ThrowOnError>({
    url: '/api/activity/export',
    ...options,
  });

/**
 * Full-text search across entities in the current project.
 */
export const search = <ThrowOnError extends boolean = false>(
  options?: Options<SearchData, ThrowOnError>,
) =>
  (options?.client ?? client).get<SearchResponses, unknown, ThrowOnError>({
    url: '/api/search',
    ...options,
  });
